import React from 'react'
import { IconWrapper } from './styles'

type Props = {
  active: boolean,
  color?: string
}

const ArrowIcon = (props: Props) => {
  return (
    <IconWrapper
      active={props.active}
      fill={props.color}
      focusable='false'
      viewBox='0 0 24 24'
      aria-hidden='true'
      role='presentation'
    >
      <path d='M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' />
      <path fill='none' d='M0 0h24v24H0z' />
    </IconWrapper>
  )
}

export default ArrowIcon
